import React from 'react';
import { Tabs } from "antd";
import AddWorkSpace from './workSpace';
import AddMeetingRoom from './meetingRoom';
import AddClass from './class';
import AddEvent from './event';
import AddConsultatin from './consultation';
function AddService(props) {

    const items = [
        {
            label: "فضای کار",
            key: "workSpace",
            children: <AddWorkSpace />,
          },
          {
            label: "اتاق جلسات",
            key: "meetingRoom",
            children: <AddMeetingRoom />,
          },
          {
            label: "کلاس",
            key: "class",
            children: <AddClass />,
          },
          {
            label: "رویداد",
            key: "event",
            children: <AddEvent />,
          },
          {
            label: "مشاوره",
            key: "consultation",
            children: <AddConsultatin />,
          },
    ]
    return (
        <div>
            <Tabs items={items} />
        </div>
    );
}

export default AddService;